window.Informacao = Backbone.Model.extend({

});

window.Informacoes = Backbone.Collection.extend({
    model: Informacao
});